module.exports = __webpack_public_path__ + "static/media/9C.4f8d0d8f.png";